import { Select, MenuItem, makeStyles, InputLabel } from '@material-ui/core';
import { profileSortingOptions } from '../../constants/constants';

const useStyles = makeStyles((theme) => ({
  icon: {
    fill: '#000000',
  },
  label: {
    color: '#9e9e9e',
  },
  selectMenu: {
    fontWeight: '600',
    marginTop: '0.4rem',
    paddingBottom: '0.4rem',
    width: '87%',
    '&:before': {
      borderColor: '#9e9e9e ',
    },
    '&:after': {
      borderColor: '#009688',
    },
  },
  menuItem: {
    color: '#009688',
  },
}));

const ProfilesSortDropdownMenu = ({ name, onChangeHandler, value }) => {
  const classes = useStyles();

  const handleChange = (e) => {
    onChangeHandler(e.target.value);
  };

  return (
    <>
      <InputLabel className={classes.label} id={`${name}-label`}>
        {name}
      </InputLabel>
      <Select className={classes.selectMenu} inputProps={{ classes: { icon: classes.icon } }} labelId={`${name}-label`} id={name} value={value} onChange={handleChange} label={name}>
        <MenuItem className={classes.menuItem} value={profileSortingOptions.EMAIL}>
          Email
        </MenuItem>
        <MenuItem className={classes.menuItem} value={profileSortingOptions.FIRST_NAME}>
          First Name
        </MenuItem>
        <MenuItem className={classes.menuItem} value={profileSortingOptions.LAST_NAME}>
          Last Name
        </MenuItem>
      </Select>
    </>
  );
};

export default ProfilesSortDropdownMenu;
